// Use this to mark the result of a promise as explicitly ignored.
// In other words "go do this thing, I'm not waiting for you to finish, and I don't care if you succeed"
export function unawaited(promise: Promise<unknown>) {
  promise.then();
}
